import {Card, CardContent, CircularProgress, Typography} from '@mui/material';

export interface AdminQuestionReviewQuestionCountProps {
  count: number | null;
  loading: boolean;
}

export default function AdminQuestionReviewQuestionCount({count, loading}: AdminQuestionReviewQuestionCountProps) {
  if (count === null) return null;

  return (
    <Card sx={{mb: 3}}>
      <CardContent>
        <Typography variant="h6" sx={{color: '#1B263B', mb: 1}}>
          Questions Matching Filters
        </Typography>
        <Typography variant="h4" sx={{color: '#1B263B', fontWeight: 600}}>
          {loading ? <CircularProgress size={24} /> : count}
        </Typography>
      </CardContent>
    </Card>
  );
}
